export enum delivererTypes {
  GET_ALL_DELIVERERS = 'GET_ALL_DELIVERERS',
  GET_UNPAGINATED_DELIVERERS = 'GET_UNPAGINATED_DELIVERERS',
  GET_DELIVERER_BY_ID = 'GET_DELIVERER_BY_ID',
  UPDATE_DELIVERER = 'UPDATE_DELIVERER',
  DELETE_DELIVERER = 'DELETE_DELIVERER',
  POST_DELIVERER = 'POST_DELIVERER',
}
